/**
 * Token Decoder Utility
 * Reads a JWT's payload (the session manager uses it for expiry). Invitation
 * links are checked in components/Auth/authLinks.ts.
 */

/**
 * Base64URL decode function
 * Converts base64url to regular base64 then decodes
 */
function base64UrlDecode(str: string): string {
  // Replace URL-safe characters with standard base64 characters
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  
  // Add padding if necessary
  const padding = base64.length % 4;
  if (padding) {
    base64 += '='.repeat(4 - padding);
  }
  
  try {
    return atob(base64);
  } catch (error) {
    throw new Error('Invalid base64url string');
  }
}

/**
 * Decodes JWT payload safely using base64url decoding
 * @param jwtToken - Full JWT token (header.payload.signature)
 * @returns Decoded payload object or null if invalid
 */
export function decodeJWTPayload(jwtToken: string): any | null {
  try {
    const parts = jwtToken.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT format: expected 3 parts separated by dots');
      return null;
    }
    
    const payload = parts[1];
    const decoded = base64UrlDecode(payload);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Failed to decode JWT payload:', error);
    return null;
  }
}